<script>
import Bar from '../components/widgets/bar.vue'

export default {
  name: "monthly-progress",
  components: {
    Bar
  },
  props: {
    revenueAndNetProfitData: {
      type: Object,
      default: () => {
      },
    },
    revenueAndNetProfitOptions: {
      type: Object,
      default: () => {
      },
    },
    revenueAndNetProfitPlugins: {
      type: Array,
      default: () => [],
    },
    quantityData: {
      type: Object,
      default: () => {
      },
    },
    quantityOptions: {
      type: Object,
      default: () => {
      },
    },
    quantityPlugins: {
      type: Array,
      default: () => [],
    },
    data: {
      type: Object, default: () => {
      },
    },
    options: {
      type: Object, default: () => {
      },
    }

  },
  data() {
    return {
      revenueAndNetProfitChartData: this.revenueAndNetProfitData,
      revenueAndNetProfitChartOptions: this.revenueAndNetProfitOptions,
      revenueAndNetProfitChartPlugins: this.revenueAndNetProfitPlugins,
      quantityChartData: this.quantityData,
      quantityChartOptions: this.quantityOptions,
      quantityChartPlugins: this.quantityPlugins,
    }
  },
}
</script>

<template>
  <div class="col-12">
    <b-card class="shadow-sm mb-4" no-body>
      <b-card-body>
        <h3 class="dashboard-card-header mb-4">Progress Tahunan</h3>

        <b-row>
          <b-col class="mb-3 mb-md-0" cols="6" lg="6" md="12">
            <b-card>
              <h3 class="dashboard-card-header mb-2">Revenue dan Net Profit</h3>
              <bar
                  key="revenue-and-net-profit-chart"
                  :data="revenueAndNetProfitChartData"
                  :height="300"
                  :options="revenueAndNetProfitChartOptions"
                  :plugins="revenueAndNetProfitPlugins"
              />
            </b-card>
          </b-col>

          <b-col class="mb-3 mb-md-0" cols="6" lg="6" md="12">
            <b-card>
              <h3 class="dashboard-card-header mb-2">Tonase</h3>
              <bar
                  key="quantity-chart"
                  :data="quantityChartData"
                  :height="300"
                  :options="quantityChartOptions"
                  :plugins="quantityChartPlugins"
              />
            </b-card>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </div>
</template>

<style lang="scss" scoped>
.overview-card-title {
  color: #667085;
  font: 500 16px/24px Inter;
}

.overview-card-body {
  color: #1664D8;
  font: 800 20px/28px Inter;
}
</style>